import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Box,
  Grid,
  Button,
  TextField,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  IconButton,
  FormControl,
  makeStyles,
  Typography,
  CircularProgress,
  Dialog,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import { useContext } from "react";
// import ViewCmoDetails from "./ViewCmoDetails";
// import StorageLocationDrawer from "./StorageLocationDrawer";
import AssociatedTeammembersDrawer from "./AssociatedTeammembersDrawer";

import {
  Edit,
  Visibility,
  Search as SearchIcon,
  ArrowDropDown,
  Refresh,
  ChevronLeft,
  ChevronRight,
} from "@material-ui/icons";
import Autocomplete from "@material-ui/lab/Autocomplete";

import moment from "moment";
import axios from "axios";
import { useDispatch } from "react-redux";
import { appUrl } from "../../../../../utils/config";
// import React, { useState } from "react";
import {
  DESTROY_BACKDROP,
  OPEN_BACKDROP,
} from "../../../containers/actions/types";
import { saveDashboardFilters, fetchAllDashboardFilters } from '../../../containers/utils/filterUtils';

import CMOCheckModal from "./ModalPopups/CMOCheckModal";
import ConfigProductDetails from "../../pharmaCo/ConfigProductDetails/ConfigProductDetails";
import StyledDialog from '../../../../common/models/Dialog';
import { useApiBaseUrl } from "../CommonMethods/CommonMethods";
const useStyles = makeStyles((theme) => ({
  blueButton: {
    backgroundImage: "linear-gradient(to right, #301232, #1A2D6C, #173072)",
    color: "white",
    border: "1px solid black",
    textTransform: "none",
    borderRadius: "2rem",
    paddingLeft: "16px",
    paddingRight: "16px",
    "&:hover": {
      backgroundColor: "green",
      background: "green",
      color: "white",
      border: "1px solid green",
    },
  },
  formControl: {
    minWidth: 180,
    // backgroundColor: "#F0F0F0",
    // borderRadius: "4px 0 0 4px",
    // border: "1px solid black",
    // borderRight: "none",
    // height: 40,
  },
  iconButtonStyle: {
    color: "black",
    border: "1px solid black",
    borderRadius: "5px",
    padding: "4px",
  },
  select: {
    height: 40,
    paddingTop: 0,
    paddingBottom: 0,
    display: "flex",
    alignItems: "center",
  },
  textField: {
    flexGrow: 1,
    height: 40,
  },
  searchButton: {
    backgroundColor: "#E25F1D",
    minWidth: 40,
    height: 40,
    borderRadius: "0 4px 4px 0",
    boxShadow: "none",
    padding: 0,
  },
  filterDropdown: {
    minWidth: 150,
    // backgroundColor: "#F0F0F0",
    height: 40,
  },
  filterSelect: {
    height: 40,
    paddingTop: 0,
    paddingBottom: 0,
    display: "flex",
    alignItems: "center",
  },
}));



const CmosNetwork = () => {
  const classes = useStyles();
  //const [search, setSearch] = useState("");
  const [searchBy, setSearchBy] = useState("");
  const [noOfPages, setNoOfPages] = useState(null);

  const [manufacturingSupplyType, setManufacturingSupplyType] = useState("all");

  const [status, setStatus] = useState("all");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [lastSyncTime, setLastSyncTime] = useState(new Date());
  const [productOptions, setProductOptions] = useState([]);
  const [productModalities, setProductModalities] = useState([]);

  const [facilityTypes, setFacilityTypes] = useState([]);
  const [selectedFacilityType, setSelectedFacilityType] = useState("all");

  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const [filterData, setFilteredData] = useState([]);

  const [showSuggestions, setShowSuggestions] = useState(false);
  const [vendorMosymphonyID, setVendorMosymphonyID] = useState("all");

  const [selectedProductModality, setSelectedProductModality] = useState("all");

  // const [drawerOpen, setDrawerOpen] = useState(false);
  // const [selectedStorageLocations, setSelectedStorageLocations] = useState([]);
  // Add these to your useState hooks:
  const [teamDrawerOpen, setTeamDrawerOpen] = useState(false);
  const [selectedTeamMembers, setSelectedTeamMembers] = useState([]);

  // const [selectedVendorMosymphonyID, setSelectedVendorMosymphonyID] =
  //   useState(null);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const debounceTimeoutRef = useRef(null);
  const [authDetails, setAuthDetails] = useState(null);
  const [totalNoOfRecords, settotalNoOfRecords] = useState(null);
  const [activeOperation, setActiveOperation] = useState({
    rowId: null,
    type: null, // 'view' or 'update'
  });
  const [searchString, setSearchString] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [showStepper, setShowStepper] = useState(false);
  const [selectedCMOForStorage, setSelectedCMOForStorage] = useState(null);
  const clickingSuggestion = useRef(false);
  const [saveDialogOpen, setSaveDialogOpen] = useState(false);
  const [saveDialogSuccess, setSaveDialogSuccess] = useState(true);
  const [lastSavedFilters, setLastSavedFilters] = useState({
    searchString: '',
    manufacturingSupplyType: 'all',
    selectedProductModality: 'all',
    selectedFacilityType: 'all',
    status: 'all',
  });
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  const [supplyTypeID, setSupplyTypeID] = useState("all");
  const API_BASE_URL = useApiBaseUrl(appUrl)

  const [isPageLoading, setIsPageLoading] = useState(false);
  const isFirstFilterLoad = useRef(true);
  const isClearingFilters = useRef(false);
  //const handleSearch = (e) => setSearch(e.target.value);
  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);

  const history = useHistory();
  const handleContinue = (data) => {
    setModalOpen(false);
    // setShowStepper(true);

    // Store the API response in sessionStorage for use in the stepper
    if (data.apiResponse) {
      sessionStorage.setItem("existingCmoDetailsReadOnly", JSON.stringify({
        ...data.cmoDetails?.organizationDetails,
        organizationId: data.cmoDetails?.organizationDetails?.organizationId || data.organization_id
      }));
    }

    history.push({
      pathname: "addCMO",
      state: {
        ...data,
        readOnly: true
      },
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  //   const filteredData = data.filter(item =>
  //   item.vendorName && item.vendorName.toLowerCase().includes(search.toLowerCase())
  // );
  const filteredData = data; // No local filtering!
  // const suggestions = Array.from(new Set(cmoData.map(item => item.cmoName)));
  const suggestions = Array.from(
    new Set(filteredData.map((item) => item.vendorName))
  );
  const uniqueCMONames = Array.from(
    new Set(filteredData.map((item) => item.vendorName)) //here i need to change shekar
  );
  //   const filteredData = cmoData.filter((item) => {
  //     if (status !== "all" && item.status !== status) return false;
  //     if (!searchBy || !search) return true;
  //     const fieldValue = (item[searchBy] || "").toLowerCase();
  //     return fieldValue.includes(search.toLowerCase());
  //   });
  // Filter first

  // const paginatedData = filteredData.slice(  ///shekar myakala
  //   page * rowsPerPage,
  //   page * rowsPerPage + rowsPerPage
  // );
  const paginatedData = data;

  // const uniqueCMONames = Array.from(new Set(cmoData.map(item => item.vendorName)));

  // const fetchSearchSuggestions = async (searchText) => {
  //   if (!searchText.trim()) return;

  //   try {
  //     const url=`${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/`
  //     const response = await axios.post(url, {
  //       query: searchText  // sending string as payload
  //     });

  //     console.log("response for searchSuggestions",response);

  //     const names = response.data || [];
  //     //setUniqueCMONames(names);
  //   } catch (err) {
  //     console.error("Error fetching CMO suggestions", err);
  //     //setUniqueCMONames([]);
  //   }
  // };

  useEffect(() => {
    //fetchSearchSuggestions()
  }, []);

  const fetchProductOptions = async () => {
    try {
      const url = `${API_BASE_URL}/fetchProductTypes/true`;
      const response = await axios.get(url);
      const data = response?.data?.data;


      if (data?.status === true || data?.status === "true") {
        const options = data.productTypeList.map((item) => ({
          id: item.productTypeID,
          name: item.productTypeName,
        }));
        setProductOptions(options); // Update the product options state
        return options; // Return options for immediate use
      } else {
        console.error("Failed to fetch product options.");
        return [];
      }
    } catch (error) {
      console.error("Error fetching product options:", error);
      return [];
    }
  };

  const fetchProductModalities = async () => {
    try {
      const url = `${API_BASE_URL}/fetchPlantDrugTypes/true`;
      const response = await axios.get(url);

      const drugTypeList = response.data?.data?.drugTypeList || [];

      const formatted = drugTypeList.map((item, index) => ({
        ...item,
        id: item.drugTypeID || `ID-${index + 1}`,
        name: item.drugTypeName || "",
        selected: !!item.activated,
        isNew: false,
        type: item.drugType,
        lastUpdatedBy: item.lastUpdatedBy,
      }));

      setProductModalities(formatted);
    } catch (error) {
      // Optionally handle error here
    }
  };

  const fetchFacilityTypes = async () => {
    try {
      const url = `${API_BASE_URL}/fetchFacilityTypes/true`;
      const response = await axios.get(url);
      //console.log(response);
      const list = response.data?.data?.facilityTypesList || [];
      const formatted = list.map((item, index) => ({
        id: item.facilityTypeID || `ID-${index + 1}`,
        name: item.facilityTypeName || "",
      }));
      //console.log("formateed ouput",formatted);
      setFacilityTypes(formatted);
    } catch (error) {
      setFacilityTypes([]);
    }
  };

  // Component initialization - load filters first, then data
  useEffect(() => {
    const initializeComponent = async () => {
      try {
        setIsPageLoading(true);
        // First, load product options, modalities, and facility types
        const [productOptionsResult] = await Promise.all([
          fetchProductOptions(),
          fetchProductModalities(),
          fetchFacilityTypes()
        ]);

        // Then load saved filters
        const filters = await fetchAllDashboardFilters('cmosNetworkDashboard');
        let savedFilters = (filters && filters.data && filters.data.cmosNetworkDashboard)
          ? filters.data.cmosNetworkDashboard
          : null;


        // Apply saved filters if they exist
        if (savedFilters && Object.keys(savedFilters).length > 0) {
          // Set search string
          setSearchString(savedFilters.searchString || "");

          // For manufacturingSupplyType, convert ID back to name
          if (savedFilters.manufacturingSupplyType && savedFilters.manufacturingSupplyType !== "all") {
            // Handle numeric ID from API
            const supplyTypeId = typeof savedFilters.manufacturingSupplyType === 'number' ?
              savedFilters.manufacturingSupplyType.toString() : savedFilters.manufacturingSupplyType;


            // Try to find the matching supply type by ID
            const options = productOptionsResult || productOptions;
            const supplyType = options.find(option => {
              return option.id.toString() === supplyTypeId.toString();
            });

            if (supplyType) {
              setManufacturingSupplyType(supplyType.name);
            } else {
              setManufacturingSupplyType("all");
            }
          } else {
            setManufacturingSupplyType("all");
          }

          // Set other filters
          setSelectedProductModality(savedFilters.selectedProductModality || "all");
          setSelectedFacilityType(savedFilters.selectedFacilityType || "all");
          setStatus(savedFilters.status || "all");

          // Update lastSavedFilters state
          setLastSavedFilters({
            searchString: savedFilters.searchString || "",
            manufacturingSupplyType: savedFilters.manufacturingSupplyType || "all",
            selectedProductModality: savedFilters.selectedProductModality || "all",
            selectedFacilityType: savedFilters.selectedFacilityType || "all",
            status: savedFilters.status || "all",
          });

          // Wait for state updates to be applied
          await new Promise(resolve => setTimeout(resolve, 0));

          // Now fetch data with the applied filters
          await fetchAllCMOs({
            vendorMosymphonyID: savedFilters.searchString ? nameToIdMap[savedFilters.searchString] || "all" : "all",
            supplyTypeID: savedFilters.manufacturingSupplyType || "all",
            drugTypeID: savedFilters.selectedProductModality || "all",
            facilityTypeID: savedFilters.selectedFacilityType || "all",
            status: savedFilters.status || "all",
          });
        } else {
          // If no saved filters, fetch with default values
          await fetchAllCMOs({
            vendorMosymphonyID: "all",
            supplyTypeID: "all",
            drugTypeID: "all",
            facilityTypeID: "all",
            status: "all",
          });
        }
      } catch (error) {
        console.error("Error initializing component:", error);
        // Fallback to default data fetch
        await fetchAllCMOs({
          vendorMosymphonyID: "all",
          supplyTypeID: "all",
          drugTypeID: "all",
          facilityTypeID: "all",
          status: "all",
        });
      } finally {
        setInitialLoadComplete(true);
        setIsPageLoading(false);
      }
    };

    // Only run initialization once
    if (!initialLoadComplete) {
      initializeComponent();
    }

    sessionStorage.clear();
  }, [initialLoadComplete]);

  const selectedSupplyTypeObj = productOptions.find(
    (option) => option.name === manufacturingSupplyType
  );

  // Update supplyTypeID whenever manufacturingSupplyType or productOptions changes
  useEffect(() => {
    const selectedObj = productOptions.find(
      (option) => option.name === manufacturingSupplyType
    );
    setSupplyTypeID(manufacturingSupplyType === "all" ? "all" : (selectedObj ? parseInt(selectedObj.id) : "all"));
  }, [manufacturingSupplyType, productOptions]);

  //console.log("supplyTypeid is here",supplyTypeID)
  // Build a map from vendorName to vendorMosymphonyID
  const nameToIdMap = {};
  (data || []).forEach((item) => {
    if (item.vendorName && item.vendorMosymphonyID) {
      nameToIdMap[item.vendorName] = item.vendorMosymphonyID;
    }
  });



  const fetchAllCMOs = async (filters = {}) => {
    setIsPageLoading(true);
    setError(null);

    try {
      const requestObject = {
        vendorMosymphonyID: filters.vendorMosymphonyID || "all",
        supplyTypeID: filters.supplyTypeID === "all" ? "all" : filters.supplyTypeID || "all",
        drugTypeID: filters.drugTypeID === "all" ? "all" : filters.drugTypeID || "all",
        facilityTypeID: filters.facilityTypeID === "all" ? "all" : filters.facilityTypeID || "all",
        status: filters.status || "all",
        pageNumber: page + 1,
        pageSize: rowsPerPage,
      };

      // Use filters.searchString if provided, otherwise fall back to state searchString
      const searchValue = filters.searchString !== undefined ? filters.searchString : searchString;
      if (searchValue?.trim()) {
        requestObject.searchString = searchValue;
      }


      const url = `${API_BASE_URL}/fetchNetworkCMOs`;

      const response = await axios.post(url, requestObject);

      if (response.data.status) {
        const result = response.data.data?.vendorDetailsList || [];
        if (result.length > 0) {
          setData(result);
          setFilteredData(result);
        }
        settotalNoOfRecords(response.data.totalNoOfRecords);
        setNoOfPages(response.data.data.noOfPages);
        setLastSyncTime(new Date());
      }
    } catch (error) {
      setError("Something went wrong. Please try again.");
    } finally {
      setIsPageLoading(false);
    }
  };

  // On component mount, fetch data
  // useEffect(() => {
  //   fetchAllCMOs({   vendorMosymphonyID,
  //     supplyTypeID,
  //     drugTypeID: selectedProductModality,
  //     facilityTypeID: selectedFacilityType,
  //     status: status,
  //    pageNumber: page + 1,
  //    pageSize: rowsPerPage
  //   });
  // }, [ vendorMosymphonyID,manufacturingSupplyType, selectedProductModality, selectedFacilityType, status,page,
  //   rowsPerPage]);

  const token = localStorage.getItem("authToken");
  useEffect(() => {
    if (token) {
      try {
        const base64Url = token.split(".")[1]; // Get payload
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split("")
            .map((c) => `%${("00" + c.charCodeAt(0).toString(16)).slice(-2)}`)
            .join("")
        );

        const payload = JSON.parse(jsonPayload);
        setAuthDetails(payload);
      } catch (e) {
        console.error("Invalid token", e);
      }
    }
  }, [token]);

  const viewCMO = async (row) => {
    setActiveOperation({ rowId: row.vendorMosymphonyID, type: "view" });
    try {
      // const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchVendorPlantDetails/${row.vendorMosymphonyID}`;
      // const response = await axios.get(url);

      // console.log("response", response);

      const url = `${API_BASE_URL}/viewCMODetails`;
      const requestObject = {
        cmoOrgId: row.vendorMosymphonyID,
        ecosystemId: authDetails.ecosystem_id,
      };
      const response = await axios.post(url, requestObject);


      if (/* response.data.status &&  */ response.data.status) {
        history.push({
          pathname: "viewCMO",
          state: {
            rowData: row,
            cmoOrgDetails: response.data.data.cmoDetails,
            cmoVendorDetails:
              {...response.data?.data?.vendorPlantDetails?.vendorPlantDetails, cmoSites: response.data?.data?.vendorPlantDetails?.cmoSites},
          },
        });
      } else {
        console.error("Failed to fetch vendor plant details");
      }
    } catch (error) {
      console.error("Error fetching vendor plant details:", error);
    } finally {
      setActiveOperation({ rowId: null, type: null });
    }
  };

  const updateCMO = async (row) => {
    setActiveOperation({ rowId: row.vendorMosymphonyID, type: "update" });

    try {
      const url = `${API_BASE_URL}/viewCMODetails`;
      const requestObject = {
        cmoOrgId: row.vendorMosymphonyID,
        ecosystemId: authDetails.ecosystem_id,
      };
      const response = await axios.post(url, requestObject);


      if (response.data.status) {
        const vendorPlantDetails =
          response.data.data.vendorPlantDetails.vendorPlantDetails;
        const cmoOrgDetails = response.data.data.cmoDetails;
        const responseVendorMosymphonyID =
          response.data.data.vendorPlantDetails.vendorMosymphonyID ||
          row.vendorMosymphonyID;
        const organizationId = responseVendorMosymphonyID;
        const organizationCode = cmoOrgDetails.organizationCode;
        const cmoSites =
          response.data.data.vendorPlantDetails?.cmoSites || []


        // Store cmoDetailsResponse in sessionStorage
        sessionStorage.setItem(
          "cmoDetailsResponse",
          JSON.stringify({
            organizationId: organizationId,
            organizationCode: organizationCode,
            email: cmoOrgDetails?.emailAddress,
            fullName: cmoOrgDetails?.fullName,
            phoneNumber: cmoOrgDetails?.phoneNumber,
            collaboratorTypeId: 2,
          })
        );

        // Combine all the data we have
        let combinedData = {
          cmoDetails: {
            cmoName: cmoOrgDetails.cmoName,
            cmoShortFormName: cmoOrgDetails.cmoShortFormName,
            streetAddress1: cmoOrgDetails.streetAddress1,
            streetAddress2: cmoOrgDetails.streetAddress2,
            fullName: cmoOrgDetails.fullName,
            emailAddress: cmoOrgDetails.emailAddress,
            phoneNumber: cmoOrgDetails.phoneNumber,
            city: cmoOrgDetails.city,
            state: cmoOrgDetails.state,
            postCode: cmoOrgDetails.postCode,
            country: cmoOrgDetails.country,
            organizationCode: cmoOrgDetails.organizationCode,
            vendorMosymphonyID: responseVendorMosymphonyID,
            organizationId: organizationId,
            status: row?.status,
          },
          vendorPlantDetails: {
            ...vendorPlantDetails,
            cmoSites: cmoSites,
            plantCode: vendorPlantDetails?.plantCode,
            plantCodeShortName: vendorPlantDetails?.plantCodeShortName,
            companyCode: vendorPlantDetails?.companyCode,
            siteID: vendorPlantDetails?.siteID,
            siteIDShortName: vendorPlantDetails?.siteIDShortName,
            siteAddressLine1: vendorPlantDetails?.siteAddressLine1,
            siteAddressLine2: vendorPlantDetails?.siteAddressLine2,
            mainAddress: vendorPlantDetails?.mainAddress,
            pickupAddress: vendorPlantDetails?.pickupAddress,
            eliveryAddress: vendorPlantDetails?.deliveryAddress,
            city: vendorPlantDetails?.city,
            state: vendorPlantDetails?.state,
            zipCode: vendorPlantDetails?.zipCode,
            country: vendorPlantDetails?.country,
            supplyTypeIDs: vendorPlantDetails?.supplyTypeIDs,
            drugTypeIDs: vendorPlantDetails?.drugTypeIDs,
            facilityTypeIDs: vendorPlantDetails?.facilityTypeIDs,
            plantTypeIDs: vendorPlantDetails?.plantTypeIDs,
            cmoDocumentTypesList: vendorPlantDetails?.cmoDocumentTypesList,
            purchasingOrgList: vendorPlantDetails?.purchasingOrgList,
            purchasingGroupList: vendorPlantDetails?.purchasingGroupList,
            plantStorageLocationsList:
              vendorPlantDetails?.plantStorageLocationsList,
            shipmentDuration: vendorPlantDetails?.shipmentDuration,
            siteNameFromReport: vendorPlantDetails?.siteNameFromReport,
            status: row?.status,
          },
        };


        if ((row.setup_complete === true)) {
          history.push({
            pathname: "updateCMO",
            state: {
              rowData: row,
              cmoOrgDetails: response.data.data.cmoDetails,
              cmoVendorDetails: response.data.data.vendorPlantDetails,
              selectedCMOFormData: combinedData,
              vendorMosymphonyID: responseVendorMosymphonyID,
              organizationId: organizationId,
            },
          });
          return;
        }


        // For incomplete setups, determine which step to redirect to
        let redirectPath = "updateCMO";
        let stepToContinue = 0;
        let incompleteDataFound = false;
        // Check CMO Details (Step 0)
        if (!combinedData.cmoDetails.cmoName) {
          incompleteDataFound = true;
          stepToContinue = 0;
        }
        // Check Site Details (Step 1)
        else if ((!combinedData.vendorPlantDetails.siteID && combinedData.vendorPlantDetails.cmoSites.length === 0)) {
          incompleteDataFound = true;
          stepToContinue = 1;
        }
        // Check Plant Details (Step 2)
        else if ((combinedData.vendorPlantDetails.cmoSites.length > 0 &&
           combinedData.vendorPlantDetails.cmoSites[combinedData.vendorPlantDetails.cmoSites.length-1].manufacturingPlantDataList.length > 0 && 
           !combinedData.vendorPlantDetails.cmoSites[combinedData.vendorPlantDetails.cmoSites.length-1].manufacturingPlantDataList[0].mainAddress.country &&
          !combinedData.vendorPlantDetails.cmoSites[combinedData.vendorPlantDetails.cmoSites.length-1].manufacturingPlantDataList[0].pickupAddress.country &&
        !combinedData.vendorPlantDetails.cmoSites[combinedData.vendorPlantDetails.cmoSites.length-1].manufacturingPlantDataList[0].deliveryAddress.country)) {
          incompleteDataFound = true;
          stepToContinue = 2;
        }
        // Check Configurations (Step 3)
        else if (
          !combinedData.vendorPlantDetails.shipmentDuration ||
          !combinedData.vendorPlantDetails.cmoDocumentTypesList?.some(
            (doc) => doc.activated
          )
        ) {
          incompleteDataFound = true;
          stepToContinue = 3;
        }
        // Check Purchasing Details (Step 4)
        else if (!combinedData.vendorPlantDetails.companyCode) {
          incompleteDataFound = true;
          stepToContinue = 4;
        }

        // console.log("incompleteDataFound", incompleteDataFound);
        // console.log("row.setup_complete", row.setup_complete);


        if ((row.setup_complete === false) && !incompleteDataFound) {

          stepToContinue = 5;
          // Save the current step to session storage
          sessionStorage.setItem("cmoCurrentStep", 5);
          // sessionStorage.setItem("cmoConfigFormData", JSON.stringify(combinedData));

          // Set completed steps up to the previous step
          const completedSteps = [];
          for (let i = 0; i < 6; i++) {
            completedSteps.push(i);
          }
          sessionStorage.setItem(
            "cmoCompletedSteps",
            JSON.stringify(completedSteps)
          );

          if (completedSteps.length > 1) {
            sessionStorage.setItem("siteDetailsAddedOnce", "true");
          }

          history.push({
            pathname: "addCMO",
            state: {
              rowData: row,
              cmoOrgDetails: response.data.data,
              cmoVendorDetails: response.data.data,
              selectedCMOFormData: combinedData,
              stepToContinue: 6, // Directly go to review step
              vendorMosymphonyID: responseVendorMosymphonyID,
              organizationId: organizationId,
              isPendingStatus: true,
            },
          });

          return;
        }

        // If incomplete data found, update status to "Pending"
        if (incompleteDataFound) {
          redirectPath = "addCMO";

          // Update status in both objects
          // combinedData.cmoDetails.status = "Pending";
          // combinedData.vendorPlantDetails.status = "Pending";

          // Save the current step to session storage
          sessionStorage.setItem("cmoCurrentStep", stepToContinue);
          // sessionStorage.setItem("cmoConfigFormData", JSON.stringify(combinedData));

          // Set completed steps up to the previous step
          const completedSteps = [];
          for (let i = 0; i < stepToContinue; i++) {
            completedSteps.push(i);
          }
          if (completedSteps.length > 1) {
            sessionStorage.setItem("siteDetailsAddedOnce", "true");
          }
          sessionStorage.setItem(
            "cmoCompletedSteps",
            JSON.stringify(completedSteps)
          );
        }

        // Redirect with the appropriate path and data
        if (redirectPath === "addCMO") {
          history.push({
            pathname: redirectPath,
            state: {
              rowData: row,
              cmoOrgDetails: response.data.data,
              cmoVendorDetails: response.data.data,
              selectedCMOFormData: combinedData,
              stepToContinue: incompleteDataFound ? stepToContinue : undefined,
              vendorMosymphonyID: responseVendorMosymphonyID,
              organizationId: organizationId,
              isPendingStatus: true,
            },
          });
        }
      } else {
        console.error("Failed to fetch vendor plant details");
      }
    } catch (error) {
      console.error("Error fetching vendor plant details:", error);
    } finally {
      setActiveOperation({ rowId: null, type: null });
    }
  };

  const getDisplayStatus = (status, setup_complete) => {
    if (status === "Active" && setup_complete === false) return "Pending";
    if (status === "Inactive" && setup_complete === false) return "Pending";
    if (status === "Active" && setup_complete === true) return "Active";
    if (status === "Inactive" && setup_complete === true) return "Inactive";
    // if (status === null && setup_complete === true) return "Inactive/NA";
    // if (status === null && setup_complete === false) return "Pending/NA";
    return status || "Pending"; // default case
  };



  useEffect(() => {
    // Only fetch data when page or rowsPerPage or debouncedSearch change
    // Dropdown filters are handled by their own handlers
    // Skip the first trigger to prevent duplicate call after initialization
    // Skip if currently clearing filters
    if (initialLoadComplete && !isFirstFilterLoad.current && !isClearingFilters.current) {
      fetchAllCMOs({
        vendorMosymphonyID: searchString ? nameToIdMap[searchString] || "all" : "all",
        supplyTypeID: manufacturingSupplyType === "all" ? "all" : supplyTypeID,
        drugTypeID: selectedProductModality,
        facilityTypeID: selectedFacilityType,
        status: status,
        pageNumber: page + 1,
        pageSize: rowsPerPage,
        searchString: debouncedSearch.trim(),
      });
    }

    // Mark that the first filter load has completed
    if (initialLoadComplete && isFirstFilterLoad.current) {
      isFirstFilterLoad.current = false;
    }
    // eslint-disable-next-line
  }, [
    page,
    rowsPerPage,
    debouncedSearch,
    initialLoadComplete
  ]);

  // Add this function to check if filters have changed
  const filtersChanged = () => {
    return (
      searchString !== lastSavedFilters.searchString ||
      manufacturingSupplyType !== lastSavedFilters.manufacturingSupplyType ||
      selectedProductModality !== lastSavedFilters.selectedProductModality ||
      selectedFacilityType !== lastSavedFilters.selectedFacilityType ||
      status !== lastSavedFilters.status
    );
  };

  // Add this function to save filters
  const handleSaveFilter = async () => {
    // Get the ID for the selected manufacturing supply type
    const selectedSupplyTypeObj = productOptions.find(
      (option) => option.name === manufacturingSupplyType
    );
    // Use the existing supplyTypeID variable

    const filtersToSave = {
      searchString,
      manufacturingSupplyType: manufacturingSupplyType === "all" ? "all" : supplyTypeID, // Save as "all" or numeric ID
      selectedProductModality: selectedProductModality !== "all" ? parseInt(selectedProductModality) : "all",
      selectedFacilityType: selectedFacilityType !== "all" ? parseInt(selectedFacilityType) : "all",
      status,
    };
    try {
      setIsPageLoading(true);
      await saveDashboardFilters('cmosNetworkDashboard', filtersToSave);
      setSaveDialogSuccess(true);
      setSaveDialogOpen(true);
      setLastSavedFilters(filtersToSave);
    } catch (error) {
      setSaveDialogSuccess(false);
      setSaveDialogOpen(true);
    } finally {
      setIsPageLoading(false);
    }
  };

  // Update the handleClearFilters function
  const handleClearFilters = () => {
    setIsPageLoading(true);
    
    // Set flag to prevent useEffect from triggering
    isClearingFilters.current = true;

    try {
      // Update all filter states
      setSearchString("");
      setSearchBy("");
      setManufacturingSupplyType("all");
      setSelectedProductModality("all");
      setFilteredData(data);
      setSelectedFacilityType("all");
      setStatus("all");
      setPage(0);

      // Make API call after a short delay to ensure state updates are queued
      setTimeout(() => {
        fetchAllCMOs({
          vendorMosymphonyID: "all",
          supplyTypeID: "all",
          drugTypeID: "all",
          facilityTypeID: "all",
          status: "all",
          pageNumber: 1,
          pageSize: rowsPerPage,
          searchString: "", // Clear search string
        }).finally(() => {
          setIsPageLoading(false);
          // Reset flag after a delay to ensure useEffect doesn't trigger
          setTimeout(() => {
            isClearingFilters.current = false;
          }, 50);
        });
      }, 50);
    } catch (e) {
      console.error("Error clearing filters:", e);
      setIsPageLoading(false);
      isClearingFilters.current = false;
    }
  };

  // Restore the debounce effect
  useEffect(() => {
    // Clear any existing timeout
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    // Set new timeout
    debounceTimeoutRef.current = setTimeout(() => {
      setDebouncedSearch(searchString);
    }, 300); // 300ms debounce delay

    return () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
    };
  }, [searchString]);

  const handleRefresh = () => {
    setLastSyncTime(new Date());
    // Use current filter values and the existing supplyTypeID variable
    setPage(0);
    fetchAllCMOs({
      vendorMosymphonyID,
      supplyTypeID: manufacturingSupplyType === "all" ? "all" : supplyTypeID, // Send "all" if manufacturingSupplyType is "all"
      drugTypeID: selectedProductModality,
      facilityTypeID: selectedFacilityType,
      status: status,
    });
  };

  // Handler for dropdown changes to prevent state async issues
  const handleManufacturingSupplyTypeChange = (e) => {
    const newValue = e.target.value;
    setManufacturingSupplyType(newValue);
    
    // Get the ID for the new supply type
    const selectedObj = productOptions.find(option => option.name === newValue);
    const newSupplyTypeID = newValue === "all" ? "all" : (selectedObj ? parseInt(selectedObj.id) : "all");
    
    // Call API with updated value
    setTimeout(() => {
      fetchAllCMOs({
        vendorMosymphonyID: searchString ? nameToIdMap[searchString] || "all" : "all",
        supplyTypeID: newSupplyTypeID,
        drugTypeID: selectedProductModality,
        facilityTypeID: selectedFacilityType,
        status: status,
        pageNumber: page + 1,
        pageSize: rowsPerPage,
        searchString: debouncedSearch.trim(),
      });
    }, 0);
  };

  const handleProductModalityChange = (e) => {
    const newValue = e.target.value;
    setSelectedProductModality(newValue);
    
    // Call API with updated value
    setTimeout(() => {
      fetchAllCMOs({
        vendorMosymphonyID: searchString ? nameToIdMap[searchString] || "all" : "all",
        supplyTypeID: manufacturingSupplyType === "all" ? "all" : supplyTypeID,
        drugTypeID: newValue,
        facilityTypeID: selectedFacilityType,
        status: status,
        pageNumber: page + 1,
        pageSize: rowsPerPage,
        searchString: debouncedSearch.trim(),
      });
    }, 0);
  };

  const handleFacilityTypeChange = (e) => {
    const newValue = e.target.value;
    setSelectedFacilityType(newValue);
    
    // Call API with updated value
    setTimeout(() => {
      fetchAllCMOs({
        vendorMosymphonyID: searchString ? nameToIdMap[searchString] || "all" : "all",
        supplyTypeID: manufacturingSupplyType === "all" ? "all" : supplyTypeID,
        drugTypeID: selectedProductModality,
        facilityTypeID: newValue,
        status: status,
        pageNumber: page + 1,
        pageSize: rowsPerPage,
        searchString: debouncedSearch.trim(),
      });
    }, 0);
  };

  const handleStatusChange = (e) => {
    const newValue = e.target.value;
    setStatus(newValue);
    
    // Call API with updated value
    setTimeout(() => {
      fetchAllCMOs({
        vendorMosymphonyID: searchString ? nameToIdMap[searchString] || "all" : "all",
        supplyTypeID: manufacturingSupplyType === "all" ? "all" : supplyTypeID,
        drugTypeID: selectedProductModality,
        facilityTypeID: selectedFacilityType,
        status: newValue,
        pageNumber: page + 1,
        pageSize: rowsPerPage,
        searchString: debouncedSearch.trim(),
      });
    }, 0);
  };

  // Helper validation functions for the fields
  const validateCmoFullName = (value) => {
    // Alphabets, Numbers (0-9), Spaces, Ampersand(&), Hyphen(-), Comma(,), Period (.), Forward slash (/), Apostrophes ('), Parentheses ()
    return /^[a-zA-Z0-9\s&\-,./'()]*$/.test(value);
  };
  // const handleClickView = (row) => {
  //   setSelectedCMO(row); // row should have vendorMosymphonyID and vendorName
  //   setShowClinicalSupply(true);
  // };
  const handleClickView = (row) => {
    history.push({
      pathname: `/pcmp/Pharma Co/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/products/${row.vendorMosymphonyID}`,
      state: { vendorName: row.vendorName },
    });
  };

  const handleClickView2 = (row) => {
    history.push({
      pathname: `/pcmp/Pharma Co/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/CMOTeams`,
      state: {
        vendorName: row.vendorName,
        vendorMosymphonyID: row.vendorMosymphonyID,
      },
    });
  };

  return (
    //  showProductDashboard && selectedCMO ? (

    //     <ConfigProductDetails
    //       searchField="CMO"
    //       searchValue={selectedCMO.vendorName}
    //       vendorName={selectedCMO.vendorName}
    //       selectedSupplytype={selectedCMO.supplyTypeID}
    //       onClose={() => setShowProductDashboard(false)}
    //     />
    // ) : (

    <Box p={3} position="relative">

      {/* Search Filters */}
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={8} >
          <Box display="flex" width="100%" className="select-search">
            <FormControl
              variant="outlined"
              size="small"
            >
              <Select
                id="search-by"
                value={searchBy}
                onChange={(e) => setSearchBy(e.target.value)}
                displayEmpty
                renderValue={(selected) => {
                  if (!selected) return "Select search by";
                  const labels = {
                    cmo: "CMO",
                    shortForm: "Short Form",
                    organizationSize: "Organization Size",
                    plantId: "Plant ID",
                    status: "Status",
                  };
                  return labels[selected] || selected;
                }}
                className="classes.select"
                IconComponent={ArrowDropDown}
              >
                <MenuItem value="">Select search by</MenuItem>
                <MenuItem value="cmo">CMO</MenuItem>
              </Select>
            </FormControl>

            {/* <Box display="flex" flexGrow={1}>
              <TextField
                fullWidth
                variant="outlined"
                size="small"
                placeholder="Search"
                value={search}
                // onChange={handleSearch}
                 onChange={e => setSearch(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    setPage(0);
                  }
                }}
                InputProps={{
                  style: { paddingRight: 0, height: 40, width: 400 },
                  endAdornment: (
                    <Button
                      variant="contained"
                      className={classes.searchButton}
                      onClick={() => setPage(0)}
                    >
                      <SearchIcon style={{ color: "#fff" }} />
                    </Button>
                  ),
                }}
                className={classes.textField}
              />
            </Box> */}
            {/* </Box> <Box display="flex" flexGrow={1} position="relative"> */}
            <Box
              display="flex"
              flexDirection="column"
              position="relative"
              width={400}
            >

              <TextField
                fullWidth
                variant="outlined"
                size="small"
                placeholder="Search"
                value={searchString}
                onChange={(e) => {
                  const value = e.target.value;
                  //setSearchString(value);
                  // Validate input
                  if (!validateCmoFullName(value)) {
                    return;
                    //setSearchError("Invalid characters entered.");
                  }
                  setSearchString(value);
                  setShowSuggestions(true);
                  if (value.length > 100) {
                    //setSearchError("Maximum 100 characters allowed.");
                    return;
                  } else {
                    //setSearchError(""); // Clear error
                    setShowSuggestions(true);
                    //setSearch(value);
                    //setSearchString(value);

                    // fetchAllCMOs({
                    //   vendorMosymphonyID: "all",
                    //   supplyTypeID,
                    //   drugTypeID: selectedProductModality,
                    //   facilityTypeID: selectedFacilityType,
                    //   status,
                    //   searchString: value.trim(),
                    // });

                    // if (value.trim() === "") {
                    //  // setSearchString("");
                    //   // If input is empty, re-fetch all CMO names
                    //   fetchAllCMOs({
                    //     vendorMosymphonyID: "all",
                    //     supplyTypeID,
                    //     drugTypeID: selectedProductModality,
                    //     facilityTypeID: selectedFacilityType,
                    //     status: status,
                    //     searchString: "",
                    //   });
                    //   setShowSuggestions(true); // Optionally hide suggestions
                    // } else {
                    //   fetchAllCMOs({
                    //     vendorMosymphonyID: "all",
                    //     supplyTypeID,
                    //     drugTypeID: selectedProductModality,
                    //     facilityTypeID: selectedFacilityType,
                    //     status,
                    //     searchString: value.trim(), // Only add when not empty
                    //   });
                    //   //debouncedFetchSuggestions(value); // If valid, trigger API
                    //   setShowSuggestions(true);
                    // }
                  }
                }

                }
                //error={Boolean(searchError)}
                //helperText={searchError}
                // onChange={(e) => {
                //   setSearch(e.target.value);
                //   // setShowSuggestions(true);
                // }}
                onFocus={() => setShowSuggestions(true)}
                onBlur={(e) => {
                  const { value } = e.target;
                  // Trim leading and trailing spaces for string values
                  if (typeof value === "string" && value.trim() !== value) {
                    setSearchString(value.trim());
                  }
                  // Only hide if not clicking a suggestion
                  if (!clickingSuggestion.current) {
                    setTimeout(() => setShowSuggestions(false), 300);
                  }
                }}

                inputProps={{ maxLength: 100 }}
                InputProps={{
                  style: { paddingRight: 0, height: 40, width: 400 },
                  endAdornment: (
                    // <Button
                    //   variant="contained"
                    //   className={classes.searchButton}
                    //   onClick={() => {
                    //     // Filter table to show only the selected/typed CMO
                    //     setFilteredCMOs(
                    //       cmoData.filter(item =>
                    //         item.vendorName.toLowerCase() === search.toLowerCase()
                    //       )
                    //     );
                    //     setShowSuggestions(false);
                    //   }}
                    // >
                    //   <SearchIcon style={{ color: "#fff" }} />
                    // </Button>
                    <Button
                      variant="contained"
                      className={classes.searchButton}
                      onClick={() => {
                        if (!validateCmoFullName(searchString)) {
                          //setSearchError("Invalid characters entered.");
                          return;
                        }
                        // setSearchError("");
                        const payload = {
                          vendorMosymphonyID: searchString
                            ? nameToIdMap[searchString] || "all"
                            : "all",
                          supplyTypeID,
                          drugTypeID: selectedProductModality,
                          facilityTypeID: selectedFacilityType,
                          status: status,
                          searchString: searchString,
                        };
                        fetchAllCMOs(payload);
                        setShowSuggestions(false);
                        setPage(0);
                      }}
                    >
                      <SearchIcon style={{ color: "#fff" }} />
                    </Button>
                  ),
                }}
                className={`search-textbox ${classes.textField}`}

                disabled={!searchBy}
              />
              {showSuggestions && (
                <Box
                  onMouseDown={(e) => e.preventDefault()}
                  sx={{
                    position: "absolute",
                    top: 42,
                    left: 0,
                    width: 400,
                    background: "#fff",
                    border: "1px solid #ccc",
                    zIndex: 10,
                    maxHeight: 200,
                    overflowY: "auto",
                  }}
                >
                  {(searchString.trim() === ""
                    ? uniqueCMONames
                    : uniqueCMONames.filter((name) =>
                      name?.toLowerCase().includes(searchString.toLowerCase())
                    )
                  ).map((name, idx) => (
                    <Box
                      key={idx}
                      sx={{
                        padding: "8px 12px",
                        cursor: "pointer",
                        borderBottom: "1px solid #eee",
                        "&:hover": { background: "#f5f5f5" },
                      }}
                      onClick={() => {
                        setSearchString(name);
                        //  setFilteredCMOs(data.filter(item => item.vendorName === name));

                        setShowSuggestions(false);
                      }}
                    >
                      {name}
                    </Box>
                  ))}
                </Box>
              )}
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} sm={4}>
          <Grid
            container
            spacing={1}
            justify="flex-end"
            alignItems="center"
            wrap="nowrap"
          >
            <Grid item>
              <Button
                startIcon={<AddIcon />}
                onClick={handleOpenModal}
                className={classes.blueButton}
              >
                Add New CMO
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Filter Row */}
      <Grid
        container
        spacing={1}
        alignItems="flex-end"
        style={{
          marginBottom: 16,
          marginTop: 30,
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Grid
          style={{
            display: "flex",
            gap: 15, // Reduced from 30 to 15
            alignItems: "flex-end",
          }}
          item
        >
          {/* Manufacturing Supply Type */}
          <Grid item sm="auto">
            <Box display="flex" flexDirection="column">
              <Typography className="dashboard-filter-labels">
                Manufacturing Supply Type:
              </Typography>
              <FormControl
                variant="outlined"
                size="small"
                className={`${classes.filterDropdown} dashboard-filter-dropdown`}
              >
                <Select
                  value={manufacturingSupplyType}
                  onChange={handleManufacturingSupplyTypeChange}
                  className={`${classes.filterSelect} `}
                >
                  <MenuItem value="all">All</MenuItem>
                  {productOptions.map((option) => (
                    <MenuItem key={option.id} value={option.name}>
                      {option.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Grid>

          {/* Product Modality */}
          <Grid item sm="auto">
            <Box display="flex" flexDirection="column">
              <Typography className="dashboard-filter-labels">
                Product Modality:
              </Typography>
              <FormControl
                variant="outlined"
                size="small"
                className={`${classes.filterDropdown} dashboard-filter-dropdown`}
              >
                <Select
                  value={selectedProductModality}
                  onChange={handleProductModalityChange}
                  className={classes.filterSelect}
                >
                  <MenuItem value="all">All</MenuItem>
                  {productModalities.map((modality) => (
                    <MenuItem key={modality.id} value={modality.id}>
                      {modality.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Grid>

          {/* Manufacturing Facility Type */}
          <Grid item sm="auto">
            <Box display="flex" flexDirection="column">
              <Typography className="dashboard-filter-labels">
                Manufacturing Facility Type:
              </Typography>
              <FormControl
                variant="outlined"
                size="small"
                className={`${classes.filterDropdown} dashboard-filter-dropdown`}
              >
                <Select
                  value={selectedFacilityType}
                  onChange={handleFacilityTypeChange}
                >
                  <MenuItem value="all">All</MenuItem>
                  {facilityTypes.map((type) => (
                    <MenuItem key={type.id} value={type.id}>
                      {type.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Grid>

          {/* Status */}
          <Grid item sm="auto">
            <Box display="flex" flexDirection="column">
              <Typography className="dashboard-filter-labels">
                Status:
              </Typography>
              <FormControl
                variant="outlined"
                size="small"
                style={{ width: "150px" }}
                className={`${classes.filterDropdown} dashboard-filter-dropdown`}
              >
                <Select
                  value={status}
                  onChange={handleStatusChange}
                  className={classes.filterSelect}
                >
                  <MenuItem value="all">All</MenuItem>
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                  <MenuItem value="Pending">Pending</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Grid>

          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {/* Save Filters Button */}
            <Grid item sm="auto">
              <Button
                variant="contained"
                style={{
                  borderRadius: "2rem",
                  textTransform: "none",
                  height: "40px",
                  whiteSpace: "nowrap",
                  marginLeft: "5px",
                  backgroundColor: !filtersChanged() ? "#F5B29A" : "#ec6535",
                  color: filtersChanged() ? "#fff" : "#fff",
                  minWidth: "120px",
                }}
                onClick={handleSaveFilter}
                disabled={!filtersChanged() || isPageLoading}
              >
                Save filters
              </Button>
            </Grid>

            {/* Clear All Filters */}
            <Grid item xs="auto">
              <Typography
                variant="caption"
                style={{
                  fontSize: 14,
                  color: "#286ACF",
                  textDecoration: "underline",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  marginLeft: 5,
                }}
                onClick={handleClearFilters}
              >
                Clear all filters
              </Typography>
            </Grid>
          </div>
        </Grid>

        <Grid item>
          <Box display="flex" flexDirection="column" alignItems="flex-end">
            {/* Refresh Section */}
            <Box display="flex" alignItems="center" marginBottom="8px">
              <Typography
                variant="body2"
                className="last-synced-text"
              >
                {`Last synced @ ${moment(lastSyncTime).format(
                  "HH:mm:ss; DD MMMM YYYY"
                )}`}
              </Typography>
              <Typography
                variant="body2"
                color="primary"
                
                onClick={handleRefresh}
                className="refresh-button"
              >
                Refresh
                <Refresh color="primary" fontSize="small" />
              </Typography>
            </Box>

            {/* Per Page Section */}
            <Box className="per-page-box" display="flex" alignItems="center">
              <Typography
                style={{
                  fontWeight: "bold",
                  marginRight: "8px",
                  whiteSpace: "nowrap",
                }}
              >
                PER PAGE
              </Typography>
              <FormControl variant="outlined" size="small">
                <Select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={15}>15</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Box>
        </Grid>
      </Grid>

      {/* Table */}
      <Box mt={3} className="default-table-styles" position="relative">
        {/* Table Loader Overlay */}
        {isPageLoading && (
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            display="flex"
            alignItems="center"
            justifyContent="center"
            bgcolor="rgba(255, 255, 255, 0.8)"
            zIndex={10}
            borderRadius="4px"
            minHeight="200px"
          >
            <Box textAlign="center">
              <CircularProgress size={40} />
            </Box>
          </Box>
        )}
        <TableContainer component={Paper} style={{ position: 'relative' }}>
          <Table>
            <TableHead>
              <TableRow
                style={{
                  backgroundColor: "#f5f5f5",
                }}
              >
                <TableCell>CMO</TableCell>
                <TableCell>Short Form</TableCell>
                <TableCell>CMO ID From Sponsor ERP</TableCell>
                <TableCell>Plant IDs From Sponsor ERP</TableCell>
                <TableCell>Storage Locations From Sponsor ERP</TableCell>
                {/* <TableCell>Associated Materials</TableCell> */}
                <TableCell>Associated Products</TableCell>
                <TableCell>CMO Team Members</TableCell>
                <TableCell>Associated Sponsor Team Members</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {error ? (
                <TableRow>
                  <TableCell colSpan={11}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "50px",
                        border: "2px solid #FF0000",
                        backgroundColor: "#FFF0F0",
                        width: "100%",
                      }}
                    >
                      <Typography style={{ textAlign: "center" }}>
                        {error}
                      </Typography>
                    </div>
                  </TableCell>
                </TableRow>
              ) : paginatedData.length === 0 || totalNoOfRecords === null || noOfPages === null ? (
                <TableRow>
                  <TableCell colSpan={11} align="center">
                    No records found.
                  </TableCell>
                </TableRow>
              ) : (
                paginatedData.map((row, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{row.vendorName || "NA"}</TableCell>
                    <TableCell>{row.shortFormName || "NA"}</TableCell>
                    <TableCell>{row.cmoIDFromSponsorERP || "NA"}</TableCell>
                    <TableCell>
                      {row.receivingPlantIDs && row.receivingPlantIDs.length > 0
                        ? row.receivingPlantIDs.join(", ")
                        : "NA"}
                    </TableCell>
                    <TableCell>
                      {row.receivingStorageLocationIDs && row.receivingStorageLocationIDs.length > 0
                        ? row.receivingStorageLocationIDs.join(", ")
                        : "NA"}
                    </TableCell>
                    {/* <TableCell>
                      <Typography
                        variant="body2"
                        style={{
                          color: "blue",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setSelectedStorageLocations(
                            row.storageLocations || []
                          );
                          setSelectedCMOForStorage(row.vendorName)
                          setSelectedVendorMosymphonyID(row.vendorMosymphonyID); // <-- set this in state
                          setDrawerOpen(true);
                        }}
                      >
                        {row?.storageLocations?.length > 0
                          ? `${row?.storageLocations?.length} Storage Location${row?.storageLocations?.length > 1 ? "s" : ""
                          }`
                          : "0 Storage Locations"}
                      </Typography>
                    </TableCell> */}
                    {/* <TableCell> */}
                    {/* Associated Materials: You can customize this as needed */}
                    {/* <Typography
          variant="body2"
          style={{
            color: "blue",
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          Click to view
        </Typography>
      </TableCell> */}
                    <TableCell>
                      {/* Associated Products: You can customize this as needed */}
                      <Typography
                        variant="body2"
                        style={{
                          color: "blue",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        //      onClick={() => {
                        //       setSearch(row.vendorName);
                        //         setSearchBy("CMO");
                        //   setSelectedProductRow(row);
                        //   setShowProductDashboard(true);
                        // }}
                        key={row.vendorMosymphonyID}
                        onClick={() => handleClickView(row)}
                      >
                        Click to view
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="body2"
                        style={{
                          color: "blue",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        key={row.vendorMosymphonyID}
                        onClick={() => handleClickView2(row)}
                      >
                        {row.cmoTeamMembersCount} Team Members
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="body2"
                        style={{
                          color: "blue",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setSelectedCMOForStorage(row.vendorName)
                          setSelectedTeamMembers(
                            row?.associatedSponsorTeamMembers || []
                          );
                          setTeamDrawerOpen(true);
                        }}
                      >
                        {/* {row.associatedSponsorTeamMembers.length > 0
            ? row.associatedSponsorTeamMembers.map((member) => member.userName).join(", ")
            : "0 Team Members"} */}
                        {/* {`${
                          row?.associatedSponsorTeamMembers?.length
                        } Team Member${
                          row?.associatedSponsorTeamMembers?.length === 1
                            ? ""
                            : "s"
                        }`} */}

                        {`${row?.associatedSponsorTeamMembers?.length ?? 0} Team Member${(row?.associatedSponsorTeamMembers?.length ?? 0) === 1 ? "" : "s"
                          }`}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <div
                        style={{
                          backgroundColor:
                            getDisplayStatus(row.status, row.setup_complete) === "Active"
                              ? "#408E0F"
                              : getDisplayStatus(row.status, row.setup_complete) === "Pending"
                                ? "#E78A00"
                                : "#FF0000",
                          width: "7rem",
                          color: "white",
                          padding: "5px 10px",
                          borderRadius: "5px",
                          textAlign: "center",
                        }}
                      >
                        {getDisplayStatus(row.status, row.setup_complete)}
                      </div>
                    </TableCell>
                    <TableCell>
                      <Grid style={{ display: "flex", gap: 8 }}>
                        <IconButton
                          className={classes.iconButtonStyle}
                          style={{ marginRight: "10px" }}
                          //           onClick={() => {
                          //   setSelectedCMO(row);
                          //   setDialogOpen(true);
                          // }}
                          onClick={() => viewCMO(row)}
                          disabled={activeOperation.rowId !== null}
                        >
                          {activeOperation.rowId === row.vendorMosymphonyID &&
                            activeOperation.type === "view" ? (
                            <CircularProgress size={24} />
                          ) : (
                            <VisibilityIcon />
                          )}
                        </IconButton>
                        <IconButton
                          className={classes.iconButtonStyle}
                          onClick={() => updateCMO(row)}
                          disabled={activeOperation.rowId !== null}
                        >
                          {activeOperation.rowId === row.vendorMosymphonyID &&
                            activeOperation.type === "update" ? (
                            <CircularProgress size={24} />
                          ) : (
                            <EditIcon />
                          )}
                        </IconButton>
                      </Grid>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Custom Pagination Controls */}
        {filteredData.length > 0 && (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            marginTop={2}
          >
            {/* Left Arrow */}
            <IconButton
              size="small"
              onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
              disabled={page === 0}
            >
              <ChevronLeft fontSize="small" />
            </IconButton>

            {/* Page Info in center */}
            <Typography variant="body2" style={{ margin: "0 8px" }}>
              {`${page + 1} out of ${noOfPages ? noOfPages : 1} ${noOfPages === 1 ? "Page" : "Pages"}`}
            </Typography>

            {/* Right Arrow */}
            <IconButton
              size="small"
              onClick={() =>
                setPage((prev) => (prev + 1 < noOfPages ? prev + 1 : prev))
              }
              disabled={page + 1 >= noOfPages}
            >
              <ChevronRight fontSize="small" />
            </IconButton>
          </Box>
        )}
      </Box>
      {/* <ViewCmoDetails
  open={dialogOpen}
  onClose={() => setDialogOpen(false)}
  cmo={selectedCMO}
/> */}
      {/* <StorageLocationDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        storageLocations={selectedStorageLocations}
        vendorMosymphonyID={selectedVendorMosymphonyID}
        fetchAllCMOs={fetchAllCMOs}
        cmo={selectedCMOForStorage}
      /> */}
      <AssociatedTeammembersDrawer
        open={teamDrawerOpen}
        onClose={() => setTeamDrawerOpen(false)}
        // teamMembers={selectedTeamMembers}
        teamMembers={selectedTeamMembers}
        cmo={selectedCMOForStorage}
      />
      <CMOCheckModal
        open={modalOpen}
        onClose={handleCloseModal}
        onContinue={handleContinue}
      />
      <Dialog open={saveDialogOpen} onClose={() => setSaveDialogOpen(false)} fullWidth maxWidth="sm">
        <StyledDialog
          title={saveDialogSuccess ? 'Saved successfully' : 'Failed to save filters'}
          subtitle={saveDialogSuccess ? 'Filters saved successfully!' : 'Failed to save filters.'}
          icon={!saveDialogSuccess} // false = check, true = cross
          handleClose={() => setSaveDialogOpen(false)}
          noCloseButton={true}
        />
      </Dialog>
    </Box>
  );
};

export default CmosNetwork;
